import React from 'react'
import _ from 'lodash'
import { isMobile } from 'react-device-detect'
import {
  formatMatchStatusNameToCheerForTeamMatchStatusName, isClosedMatchStatus,
  isConsideredOngoingMatchStatus,
  isNotStartedMatchStatus,
} from '@utils/utils'
import { MATCH_STATUS } from 'adv-protocol/src/GameCommon'
import { observer } from 'mobx-react'
import { MatchStatusTagWrap } from '@components/MatchStatusTag/index.style'
import { TimelineEventType } from '@interface/chat'

interface MatchStatusTagProps {
  matchStatus?: MATCH_STATUS
  matchStatusName?: string
  isTimeLine?: boolean
  timeLineEventType?: string
  timelineEventTypeName?: string
  dateOfMatch: Date
}

const isOngoingTimeLineStatus = (eventType: string): boolean => {
  return eventType !== TimelineEventType.MATCH_ENDED
}

const isClosedTimeLineStatus =  (eventType: string): boolean => {
  return eventType === TimelineEventType.MATCH_ENDED
}

export const MatchStatusTag: React.FC<MatchStatusTagProps> = observer(
  (props: MatchStatusTagProps): React.ReactElement => {
    const { matchStatus, matchStatusName, dateOfMatch, isTimeLine, timeLineEventType, timelineEventTypeName } = props

    // ********************* 실시간채팅창_응원글 패널_상태태그 *********************
    const renderMatchStatus = (): React.ReactElement => {
      if (isNotStartedMatchStatus(matchStatus)) {
        const formattedMatchStatusName =
          formatMatchStatusNameToCheerForTeamMatchStatusName({
            matchStatus,
            matchStatusName,
            dateOfMatch,
            baseDateAt: new Date(),
          })

        return (
          <div className="before-tag">
            <span className="txt">{formattedMatchStatusName}</span>
          </div>
        )
      }

      if (isConsideredOngoingMatchStatus(matchStatus, dateOfMatch)) {
        return (
          <div className="live-tag">
            <span className="txt">{matchStatusName}</span>
          </div>
        )
      }

      if (isClosedMatchStatus(matchStatus)) {
        return (
          <div className="closed-tag">
            <span className="txt">경기종료</span>
          </div>
        )
      }

      if (_.isNil(matchStatus) && !_.isEmpty(matchStatusName)) {
        return (
          <div className="before-tag">
            <span className="txt">{matchStatusName}</span>
          </div>
        )
      }

      return (
        <div className="before-tag">
          <span className="txt">알수없음</span>
        </div>
      )
    }

    // ********************* 상세BET_스포츠톡_타임라인_상태태그 *********************
    const renderTimeLineStatus = () : React.ReactElement => {

      // 경기시작, 각 세트 시작, 각 세트 종료, 득점 상태
      if (isOngoingTimeLineStatus(timeLineEventType)) {
        return (
          <div className="live-tag">
            <span className="txt">{timelineEventTypeName}</span>
          </div>
        )
      }

      // 경기종료
      if (isClosedTimeLineStatus(timeLineEventType)) {
        return (
          <div className="closed-tag">
            <span className="txt">경기종료</span>
          </div>
        )
      }

      return null
    }

    return (
      <MatchStatusTagWrap className={isMobile ? 'match-status' : 'match-status pc'}>
        {isTimeLine ? renderTimeLineStatus() : renderMatchStatus()}
      </MatchStatusTagWrap>
    )
  })

